import { getStringBytes } from 'tools/utils';

const validate = {
  getTagsErrorMsg(tags) {
    let result = '';
    const reg = /^(项目|project|qcs:)/;
    const { lang } = window;

    const pluck = (objs, str) => {
      let res = [];
      res = objs.map(item => item[str]);
      return res;
    };

    tags.forEach(obj => {
      if (!obj.Key || !obj.Value) {
        result = lang.t('cos.validate.enter_a_full_tag_key_and_tag_value');
        return false;
      }
      if (reg.test(obj.Key.toLowerCase())) {
        result = lang.t('cos.validate.tag_keys_cannot_begin_with');
        return false;
      }
      if (getStringBytes(obj.Key) > 127) {
        result = lang.t('cos.validate.tag_key_length_cannot_be_greater_than_127_characters');
        return false;
      }
      if (getStringBytes(obj.Value) > 255) {
        result = lang.t('cos.validate.tag_value_length_cannot_be_greater_than_255_characters');
        return false;
      }
      return true;
    });

    if (Array.from(new Set(pluck(tags, 'Key'))).length < pluck(tags, 'Key').length) {
      result = lang.t('cos.validate.repetitive_tag_keys_are_not_allowed');
    }
    return result;
  },
};

export default validate;
